module.exports = __webpack_public_path__ + "assets/img/ntx.d8d12450.png";